module.exports = __webpack_public_path__ + "img/logo_2.19d732a3.png";